package koala.model

import koala.modifier.addModifiers
import koala.modifier.modify
import koala.dom.AppendScope
import koala.dom.asWeb
import kotlinx.css.properties.deg
import kotlinx.html.js.div
import kotlinx.html.js.p
import web.html.HTMLElement

internal class IconMarkerBody(
    override val element: HTMLElement,
    override val labelElement: HTMLElement?,
    val bearingElement: HTMLElement? = null,
    val bearing: Float? = null
): PointMarkerBody {
    var lastBearing = 0f

    init {
        bearing?.let {
            setBearing(it)
        }
    }

    override fun update(marker: PointMarker) {
        val marker = marker as TravelMarker
        marker.bearing?.let {
            setBearing(it)
        }
    }

    fun setBearing(bearing: Float) {
        val be = this.bearingElement ?: return
        val delta = ((bearing - lastBearing + 540) % 360) - 180;
        lastBearing += delta
        val adjusted = lastBearing - 90
        be.modify(MarkerStyle.MarkerBearing.of(adjusted.deg))
    }
}

internal fun AppendScope.configureIconMarker(marker: TravelMarker): IconMarkerBody {
    with(marker) {
        val body = div {
            addModifiers(modify(MarkerStyle.Travel, MarkerStyle.Body, MarkerStyle.MarkerSvg.of(marker.icon)))
        }.asWeb()

        val bearingElement = marker.bearing?.let {
            div {
                addModifiers(MarkerStyle.Bearing)
            }.asWeb()
        }

        val labelElement = label?.let {
            p {
                addModifiers(MarkerStyle.Label)
                +it
            }.asWeb()
        }

        return IconMarkerBody(body, labelElement, bearingElement, marker.bearing)
    }
}